/* eslint "@typescript-eslint/camelcase": ["error", { "properties": "never" }] */

export default {
  header: {
    sc_o: 'navigation_header',
  },
  notification_center: {
    sc_o: 'navigation_notification_center',
    sc_o_PropActionOrigin: [
      'navigation_badge_notifications',
      'navigation_badge_no_badge',
    ],
  },
  burger: {
    open: {
      PropTrackAction: 'navigation_drawer_open',
    },
  },
};
